/** Canonical public URL for an image row. */
export function imagePathById(id, buildingId) {
  return buildingId ? `/p/${buildingId}-${id}.jpeg` : `/p/${id}.jpeg`;
}

export function imageBasename(image) {
  if (!image?.url) {
    return '';
  }
  return String(image.url).split('/').pop() || '';
}

export function imageOriginalPath(image, buildingId) {
  const basename = imageBasename(image);
  if (basename) {
    return `/p/${basename}`;
  }
  return imagePathById(image?.id, buildingId);
}

export function imageSmPath(image, buildingId) {
  const basename = imageBasename(image);
  if (basename) {
    return `/p/sm/${basename}`;
  }
  return buildingId ? `/p/sm/${buildingId}-${image?.id}.jpeg` : `/p/sm/${image?.id}.jpeg`;
}

export function imageXsPath(image, buildingId) {
  const basename = imageBasename(image);
  if (basename) {
    return `/p/xs/${basename}`;
  }
  return buildingId ? `/p/xs/${buildingId}-${image?.id}.jpeg` : `/p/xs/${image?.id}.jpeg`;
}
